import { render, staticRenderFns } from "./confirmBtns.vue?vue&type=template&id=75113c0c&scoped=true&"
import script from "./confirmBtns.vue?vue&type=script&lang=js&"
export * from "./confirmBtns.vue?vue&type=script&lang=js&"
import style0 from "./confirmBtns.vue?vue&type=style&index=0&id=75113c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75113c0c",
  null
  
)

export default component.exports